import React, { useEffect, useState } from 'react';
import { Modal } from '@ofself/shell';
import { useAuth } from '../../contexts/AuthContext';
import { useGroup } from '../../contexts/GroupContext';
import { useToast } from '../../components/common';
import { usePlace } from '../../nucleus/place';
import { createSpace } from '../nucleus/ShellChrome';
import { SheetFoot, FootButton } from '../../components/nucleus/SheetFoot';

const BLANK = { name: '', description: '' };

// NEW GROUP: a name and a line about it. What happens when its last admin
// leaves is asked when it happens, not here. Made the one way a space is made (ShellChrome.createSpace — the
// dock's New space too: encrypted from birth when you have a key), then it
// ends where joining ends: the consent page, creator variant, where you choose
// what you share with it (or nothing). That page lands you inside.
export default function NewGroup({ open, onClose }) {
    const { navigate } = usePlace();
    const toast = useToast();
    const { encKeys } = useAuth();
    const { refreshGroups } = useGroup();
    const [form, setForm] = useState(BLANK);
    const [working, setWorking] = useState(false);
    useEffect(() => { if (open) setForm(BLANK); }, [open]);

    const submit = async (e) => {
        e.preventDefault();
        const name = form.name.trim();
        if (!name || working) return;
        setWorking(true);
        try {
            const { group } = await createSpace(
                { name, description: form.description.trim() || undefined },
                { encKeys, refreshGroups },
            );
            onClose();
            if (group?.id) navigate(`/grant?to_group_id=${encodeURIComponent(group.id)}&made=1`);
        } catch (err) {
            toast.error(err.message || 'Could not make the group');
        } finally { setWorking(false); }
    };

    return (
        <Modal open={open} onClose={onClose} title="New group" size="md" lead="A shared graph with its own realms, apps and members. You are its first admin, on Full Access. Next you choose what you share with it.">
            <form className="groups-form" onSubmit={submit}>
                <label className="groups-form__label" htmlFor="ng-name">Name</label>
                <input id="ng-name" className="groups-form__field" required autoFocus value={form.name}
                    placeholder="What it is called" onChange={(e) => setForm({ ...form, name: e.target.value })} />
                <label className="groups-form__label" htmlFor="ng-desc">About it</label>
                <textarea id="ng-desc" className="groups-form__field" rows={2} value={form.description}
                    placeholder="Optional" onChange={(e) => setForm({ ...form, description: e.target.value })} />
                <p className="groups-form__note">If its last admin ever leaves, they choose then: hand it to the longest member, or close it.</p>
                <SheetFoot>
                    <FootButton onClick={onClose}>Cancel</FootButton>
                    <FootButton primary type="submit" disabled={!form.name.trim()} busy={working}>Next: what you share</FootButton>
                </SheetFoot>
            </form>
        </Modal>
    );
}
